import React from "react";
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CContainer,
    CForm,
    CFormInput,
    CRow,
} from "@coreui/react";
import { t } from "../i18n";

export default function SignupPage() {
    const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");

    return (
        <CContainer className="min-vh-100 d-flex align-items-center">
            <CRow className="justify-content-center w-100">
                <CCol md={8} lg={5} xl={4}>
                    <CCard className="shadow">
                        <CCardBody className="p-5">
                            <h1 className="mb-2">{t("auth.signupTitle")}</h1>

                            <p className="text-body-secondary mb-4">
                                {t("auth.signupSubtitle")}
                            </p>

                            <CForm method="post" action="/users">
                                <input type="hidden" name="authenticity_token" value={csrfToken} />

                                <CFormInput
                                    className="mb-3"
                                    type="email"
                                    name="user[email]"
                                    placeholder={t("auth.email")}
                                    autoComplete="email"
                                    required
                                />

                                <CFormInput
                                    className="mb-3"
                                    type="password"
                                    name="user[password]"
                                    placeholder={t("auth.password")}
                                    autoComplete="new-password"
                                    required
                                />

                                <CFormInput
                                    className="mb-4"
                                    type="password"
                                    name="user[password_confirmation]"
                                    placeholder={t("auth.confirmPassword")}
                                    autoComplete="new-password"
                                    required
                                />

                                <CButton color="primary" type="submit" className="w-100 mb-3">
                                    {t("auth.signupButton")}
                                </CButton>
                            </CForm>

                            <CForm method="post" action="/users/auth/google_oauth2">
                                <input type="hidden" name="authenticity_token" value={csrfToken} />

                                <CButton color="light" type="submit" className="w-100 mb-3">
                                    {t("auth.continueWithGoogle")}
                                </CButton>
                            </CForm>

                            <div className="text-center">
                                <span className="text-body-secondary">{t("auth.hasAccount")}</span>
                                <a href="/login">{t("auth.loginLink")}</a>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    );
}
